<template>
  <v-card class="mt-0" flat>
    <template v-for="(d, name, index) in departments">
      <h4 :key="index">{{ name }}</h4>
      
      <v-expand-transition :key="index" v-if="d && d.length > 0">
        <v-expansion-panels class="mt-0">
          <v-expansion-panel
            v-for="(exemption) in d"
            :key="exemption.id"
            :aria-label="$t('labels.existing-applications')"
          >
            <v-expansion-panel-header expand-icon="$sl-arrow-down" two-line>
              <div>
                <div class="header-title text-capitalize" v-if="exemption && exemption.person">
                  {{ exemption.person | fullName }}
                </div>
                <div class="ellipsis">
                  <div class="caption gray">
                    {{ $t('company.exemption-type') }} ({{ getProfessionString(exemption.professions) }})
                  </div>
                </div>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div v-for="(p, idx) in exemption.professions" :key="'key_' + idx">
                <h6 class="subtitle-2">{{ $t('company.exemption-type') }}: {{ p.name }}</h6>
                <p class="caption">
                  {{ $t('company.exemption-issued-by') }} {{ p | fullName }} {{ p.approvedOn | date }}
                </p>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-expand-transition></template
    >
  </v-card>
</template>

<script>
import API from '@/services/api.js'
import ActionButton from '@/components/Common/ActionButton'
import filter from 'lodash/filter'
import find from 'lodash/find'
import groupBy from 'lodash/groupBy'
import assign from 'lodash/assign'

const SugarDate = require('sugar/date')

export default {
  name: 'CompanyPausedPersonDetail',

  props: {
    searched: {
      type: Array,
      default: []
    }
  },
  components: {
    ActionButton
  },
  created() {
    this.init()
  },
  data() {
    return {
      departments: [],
      noDepartment: []
    }
  },
  computed: {},

  methods: {
    init() {
      //console.log(this.$route.params.id, 'init', this.searched)
      let empDep = []
      let noDep = []
      this.searched.forEach(se => {
        let foundComp = se.person.employments.find(x => x.companyId == this.$route.params.id)
        //console.log(this.$route.params.id, 'found', foundComp)
        foundComp.departmentEmployments.forEach(dep => {
          empDep.push({
            id: se.id,
            depName: dep.department.name,
            person: se.person,
            professions: se.professions
          })
        })

        // if (em.departmentEmployments.length == 0) {
        //   noDep.push({
        //     id: em.id,
        //     employed: em.employed,
        //     departmentEmployments: em.departmentEmployments,
        //     depName: this.$t('company.missing-department'),
        //     roles: '',
        //     isAdministrator: em.isAdministrator,
        //     isDepartmentAdministrator: false,
        //     isCompanyEducationResponsible: false,
        //     isDistanceEducationAdministrator: false,
        //     isInstructor: false
        //   })
        // console.log('nollan;;', this.noDepartment)
        //}
        // em.departmentEmployments.forEach(dep => {
        //   empDep.push({
        //     id: em.id,
        //     employed: em.employed,
        //     departmentEmployments: em.departmentEmployments,
        //     depName: dep.department.name,
        //     roles: dep.roles,
        //     isDepartmentAdministrator: dep.isDepartmentAdministrator,
        //     isAdministrator: em.isAdministrator,
        //     isCompanyEducationResponsible: dep.isDepartmentEducationResponsible,
        //     isDistanceEducationAdministrator: dep.isDepartmentDistanceEducationAdministrator,
        //     isInstructor: dep.isDepartmentInstructor
        //   })
        // })
      })
      this.noDepartment = groupBy(noDep, function (o) {
        return o.depName
      })
      this.departments = groupBy(empDep, function (o) {
        return o.depName
      })
      this.departments = assign(this.departments, this.noDepartment)
    },
    /**
     * @vuese
     * Used to transform profession to string devided by a comma
     * @arg The argument is an array representing professions
     */
    getProfessionString(p) {
      let ret = ''
      p.forEach((element, index) => {
        if (ret != '') ret += ', '
        ret += element.name
      })
      return ret.replace(/\s*,\s*/g, ', ')
    }
  }
}
</script>
<style  scoped>
</style>
